module.exports = __webpack_public_path__ + "media/test-idea/balloon-logo-19f45e55.png";